// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2283266b","93":"9af0c6bd","177":"9c2959a3","200":"037786b5","318":"df56b735","344":"1f552c10","474":"a84b510c","498":"a9586c4b","639":"d4973d74","648":"4fdf69a3","716":"5f893e00","732":"505b9f46","742":"54f4049c","948":"0de73f5b"}[chunkId] + ".chunk.js";
};